<template>
    <div class="page-main" style="margin-top:60px;">
        <!-- <CampaignDetailHeader></CampaignDetailHeader> -->
        <CampaignDetailIframe ></CampaignDetailIframe>
    </div>
</template>

<script>
import CampaignDetailHeader from '@/components/campaign-detail/CampaignDetailHeader';
// import CampaignDetailGrid from '@/components/campaign-detail/CampaignDetailGrid'
// import CampaignDetailFooter from '@/components/campaign-detail/CampaignDetailFooter'
// import CampaignDetailGridAction from '@/components/campaign-detail/CampaignDetailGridAction'
import CampaignDetailIframe from '@/components/campaign-detail/CampaignDetailIframe';


export default {
    name: 'campaignEditDetail',
    data() {
        return {
			data:{
				campaignName:'',
				campaignId:''
			}
		}
    },
    components: {
         CampaignDetailHeader,
        // CampaignDetailGrid,
        // CampaignDetailFooter,
        // CampaignDetailGridAction,
		CampaignDetailIframe
    },
    mounted() {
		console.log('mounted');
    }

}
</script>

<style scoped src="@/assets/css/main.css"></style>
<style lang="scss">
.main-header {
    margin-top: 50px !important;
}
</style>
